<template>
  <div class="body">
    <div class="body-item">
      <div class="body-item-main">
        <div class="visit2" v-loading="!!chart_loading['visit8']">
          <div class="visit-title">催缴力分析</div>
          <div class="visit-chart2" ref="visit8"></div>
        </div>
        <div class="visit2" v-loading="!!chart_loading['visit7']">
          <div class="visit-title">催缴统计（合计）</div>
          <div class="visit-chart2" ref="visit7"></div>
        </div>
        <div class="visit2" v-loading="!!chart_loading['visit1']">
          <div class="visit-title">催缴统计（线上）</div>
          <div class="visit-chart2" ref="visit1"></div>
        </div>
        <div class="visit2" v-loading="!!chart_loading['visit2']">
          <div class="visit-title">催缴统计（线下）</div>
          <div class="visit-chart2" ref="visit2"></div>
        </div>
        <div class="visit2" v-loading="!!chart_loading['visit3']">
          <div class="visit-title">函件催缴统计（线下）</div>
          <div class="visit-chart2" ref="visit3"></div>
        </div>
<!--        <div class="visit2" v-loading="!!chart_loading['visit4']">-->
<!--          <div class="visit-title">诉讼催缴统计（线下）</div>-->
<!--          <div class="visit-chart2" ref="visit4"></div>-->
<!--        </div>-->
<!--        <div class="visit2" v-loading="!!chart_loading['visit5']">-->
<!--          <div class="visit-title">第三方催缴统计（线下）</div>-->
<!--          <div class="visit-chart2" ref="visit5"></div>-->
<!--        </div>-->
        <div class="visit2" v-loading="!!chart_loading['visit6']">
          <div class="visit-title">已缴费登记统计</div>
          <div class="visit-chart2" ref="visit6"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import ButlerHttp from "./common/ButlerHttp";
export default {
  name: "LegalStatistics",
  inject:['where','reginWhere'],
  props:{
    typeId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    regionId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    projectId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    areaId:{
      type:Number|String,
      default(){
        return ""
      }
    },
    projectIds:{
      type:Array|String,
      default(){
        return "";
      }
    }
  },
  data(){
    return{
      list:[],
      chart_list:{},
      chart_loading:{
        visit1:true,
        visit2:true,
        visit3:true,
        visit4:true,
        visit5:true,
        visit6:true,
        visit7:true,
        visit8:true,
      },
    }
  },
  mounted() {
    const that=this;
    that.chart_list={}
    window.onresize=function () {
      let chart_list_ids=Object.keys(that.chart_list)
      chart_list_ids.map(ret=>{
        that.chart_list[ret].resize();
      });
    }
  },
  methods:{
    reData(){
      const that = this;
      that.chart_loading.visit1=true;
      that.chart_loading.visit2=true;
      that.chart_loading.visit3=true;
      that.chart_loading.visit4=true;
      that.chart_loading.visit5=true;
      that.chart_loading.visit6=true;
      that.chart_loading.visit7=true;
      that.chart_loading.visit8=true;
      that.get12MonthList(list=>{
        that.getChart('visit8',visitOption2([
          {
            type:'bar',
            field: 'plan_count',
            name: "户数(标准)",
            yAxisIndex: 0,
            color: "#84c0f6",
          },
          {
            type:'bar',
            field: 'actual_count',
            name: "户数（实催）",
            yAxisIndex: 0,
            color: "#5571c6",
          },
          // {
          //   type:'bar',
          //   field: 'actual_amount',
          //   name: "金额（实催）",
          //   yAxisIndex:1,
          // },
          // {
          //   type:'bar',
          //   field: 'hk_count',
          //   name: "户数（回款）",
          //   yAxisIndex: 0,
          // },
          // {
          //   type:'bar',
          //   field: 'hk_amount',
          //   name: "金额（回款）",
          //   yAxisIndex: 1,
          // },
          {
            type: 'line',
            field: 'task_finish_rate1',
            name: "任务完成率",
            yAxisIndex: 1,
            color: "#92cd76",
          },
          {
            type: 'line',
            field: 'hk_rate1',
            name: "催回效率",
            yAxisIndex: 1,
          },
          {
            type: 'line',
            field: 'urge_rate1',
            name: "回款率",
            yAxisIndex: 1,
          },
        ],list))
        that.chart_loading.visit8=false;
      })
      that.getData("",list=>{
        that.getChart('visit7',visitOption1([
          {
            "type": 0,
            "type_ex": 0,
            "name": "合计"
          }
        ],list))
        that.chart_loading.visit7=false;
      })
      that.getData("1,2,3,15",list=>{
        that.getChart('visit1',visitOption1([
          {
            "type": 1,
            "type_ex": 0,
            "name": "短信"
          },
          {
            "type": 2,
            "type_ex": 0,
            "name": "催费函"
          },
          {
            "type": 3,
            "type_ex": 0,
            "name": "法务函"
          },
          {
            "type": 15,
            "type_ex": 0,
            "name": "一户一码"
          },
        ],list))
        that.chart_loading.visit1=false;
      })
      that.getData("7,8,9,11,6",list=>{
        that.getChart('visit2',visitOption1([
          {
            "type": 7,
            "type_ex": 0,
            "name": "上门"
          },
          {
            "type": 8,
            "type_ex": 0,
            "name": "电话"
          },
          {
            "type": 9,
            "type_ex": 0,
            "name": "微信"
          },
          {
            "type": 11,
            "type_ex": 0,
            "name": "短信"
          },
          {
            "type": 6,
            "type_ex": 0,
            "name": "立码付"
          },
        ],list))
        that.chart_loading.visit2=false;
      })
      that.getData("12,13,4",list=>{
        that.getChart('visit3',visitOption1([
          {
            "type": 12,
            "type_ex": 0,
            "name": "催费函"
          },
          {
            "type": 13,
            "type_ex": 0,
            "name": "法务函"
          },
          {
            "type": 4,
            "type_ex": 0,
            "name": "律师函"
          },
        ],list))
        that.chart_loading.visit3=false;
      })
      // that.getData("5",list=>{
      //   that.getChart('visit4',visitOption1([
      //     {
      //       "type": 5,
      //       "type_ex": 1,
      //       "name": "提交"
      //     },
      //     {
      //       "type": 5,
      //       "type_ex": 2,
      //       "name": "诉调"
      //     },
      //     {
      //       "type": 5,
      //       "type_ex": 3,
      //       "name": "立案"
      //     },
      //   ],list))
      //   that.chart_loading.visit4=false;
      // })
      // that.getData("14",list=>{
      //   that.getChart('visit5',visitOption1([
      //     {
      //       "type": 14,
      //       "type_ex": 0,
      //       "name": "第三方催费"
      //     }
      //   ],list))
      //   that.chart_loading.visit5=false;
      // })
      that.getData("10",list=>{
        that.getChart('visit6',visitOption1([
          {
            "type": 10,
            "type_ex": 0,
            "name": "已缴费登记"
          },
        ],list))
        that.chart_loading.visit6=false;
      })
    },
    getData(select_type="1,2,3",callback){
      const that = this;
      let where = {}
      if(that.regionId) where.region_id=that.regionId;
      if(that.projectId) where.project_id=that.projectId;
      if(that.projectIds) where.project_ids=that.projectIds;
      if(that.areaId) where.area_id=that.areaId;
      if(that.reginWhere.age) where.age=that.reginWhere.age;
      where.select_type=select_type;
      ButlerHttp.post("Legal/statistics", where, res => {
        if (res.code) {
          if (that.list.length) {
            res.data.map((re, index) => {
              that.list[index] = {
                ...that.list[index],
                ...re
              };
            });
          } else {
            that.list = res.data;
          }
          typeof callback === "function" && callback(that.list);
          // that.initChartVisit()
        }
      });
    },
    get12MonthList(callback){
      const that = this;
      let where = {}
      if(that.regionId) where.region_id=that.regionId;
      if(that.projectId) where.project_id=that.projectId;
      if(that.projectIds) where.project_ids=that.projectIds;
      if(that.areaId) where.area_id=that.areaId;
      if(that.reginWhere.age) where.age=that.reginWhere.age;
      where.age_types="1,2"
      ButlerHttp.post("ProjectCollectionUrgePayment/get12MonthList",{
        ...where,
      },res=>{
        if(res.code){
          callback(res.data)
        }
      })
    },
    getChart(id,option) {
      const that=this;
      let _chart={}
      if(that.chart_list[id]){
        _chart=that.chart_list[id];
        // _chart = echarts.getInstanceByDom(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }else {
        const _chart = echarts.init(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }
      return _chart;
    }
  },
  watch:{

  },
  unmounted() {
    this.chart_list={}
  }
}
function rand(num=100) {
  return Math.floor(Math.random()*num)
}
function visitOption1(groupName=[],list) {
  let cateName=list.map(ret=>ret.ym);
  let cateData=[];
  let keys=[];
  if(groupName.length>1){
    groupName.push({
      "type": 100,
      "type_ex": 0,
      "name": "合计"
    })
    keys=groupName.map(ret=>{
      let k="count_"+ret.type;
      if(ret.type_ex){
        k=k+"_"+ret.type_ex
      }
      return k;
    })
    list=list.map(ret=>{
      ret.count_100=0;
      keys.forEach(val=>{
        if(val!=='count_100'){
          ret.count_100=ret.count_100+Number(ret[val]);
        }
      })
      return ret;
    })
  }

  groupName.forEach((ret,index)=>{
    let count_name='count_'+ret.type;
    if(ret.type_ex){
      count_name=count_name+'_'+ret.type_ex;
    }
    cateData[index]=list.map(ret=>ret[count_name]||0)
  })
  let d={
    "cateName":cateName,
    "cateData":cateData,
    "groupName":groupName.map(ret=>ret.name)
  }
  const colors = [
    '#0173e7',
    '#1aad3d',
    '#e88b20',
    '#f65555',
    '#38bcbe'
  ];

  let series=[];
  groupName.forEach((ret,index)=>{
    if(ret.type===100){
      series[index]={
        name: ret.name,
        type: 'line',
        data: d.cateData[index],
        color:"#a964b4",
        label: {
          show: true,
          position: 'top'
        },
      }
    }else {
      series[index]={
        name: ret.name,
        type: 'bar',
        stack: "总数",
        data: d.cateData[index],
        color:colors[index],
        label: {
          show: true,
          position: 'top'
        },
      }
    }
  })


  return {
    grid: {
      x: '5%',
      width: '90%',
      // y: '12%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: d.groupName
    },
    xAxis: [
      {
        type: 'category',
        data: d.cateName,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '次',
      }
    ],
    series: series
  };
}

function visitOption2(groupName=[],list) {
  let cateName=list.map(ret=>ret.ym);
  let cateData=[];
  let keys=[];
  if(groupName.length>1){
    keys=groupName.map(ret=>ret.field)
  }

  groupName.forEach((ret,index)=>{
    cateData[index]=list.map(rets=>rets[ret.field]||0)
  })
  let yAxis=[
    {
      type: 'value',
      name: '户',
      position: 'left',
      splitLine: { show: false },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    // {
    //   type: 'value',
    //   name:'元',
    //   position: 'left',
    //   splitLine: { show: false },
    //   axisLine: { show: false },
    //   axisTick: { show: false },
    //   axisLabel:{
    //     formatter: function(value) {
    //       if(value>100000000){
    //         return Math.round(value/100000000)+'亿'
    //       }else if(value>10000){
    //         return Math.round(value/10000)+'万'
    //       }else {
    //         return value
    //       }
    //     }
    //   }
    // },
    {
      type: 'value',
      name:'%',
      position: 'right',
      // offset: 65,
      splitLine: { show: true },
      axisLine: { show: false },
      axisTick: { show: false }
    },
  ]
  let d={
    "cateName":cateName,
    "cateData":cateData,
    "groupName":groupName.map(ret=>ret.name)
  }
  const colors = [
    '#0173e7',
    '#1aad3d',
    '#e88b20',
    '#f65555',
    '#38bcbe'
  ];

  let series=[];
  groupName.forEach((ret,index)=>{
    series[index]={
      name: ret.name,
      type: ret.type,
      yAxisIndex: ret.yAxisIndex,
      data: d.cateData[index],
      color:ret.color||colors[index],
      showSymbol: false,
      label: {
        show: false,
        position: 'top'
      },
    }
  })


  return {
    grid: {
      top: 50,
      bottom: 50,
      left: 50,
      right: 40,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        },
      }
    },
    toolbox: {
      feature: {
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: d.groupName
    },
    xAxis: [
      {
        type: 'category',
        data: d.cateName,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: yAxis,
    series: series
  };
}

</script>

<style lang="scss" scoped>

.body{
  display: flex;
  flex-direction: column;
  background-color: aliceblue;
  .body-item{
    .body-item-header{
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
    }
    .body-item-main{
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.visit1{
  width: calc( 50% - 30px );
  height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart1{
    width: calc( 100% - 30px );
    height: calc(448px - 80px);
  }
  .visit-chart3{
    width: 400px;
    height: 400px;
  }
  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}


.visit2{
  width: calc( 100% - 10px );
  //height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-chart2{
    width: calc( 100% - 10px );
    height: calc(448px - 30px);
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/LegalStatistics.vue